import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import globals from '@/utils/globals';
import {
	DecisionMakingServiceViewChangedEvent,
	ListType,
	ViewType,
} from '@studyportals/decision-making-service-interfaces';
import store from '..';

export class DecisionMakingServicePlugin implements ISubscriber<DecisionMakingServiceViewChangedEvent> {
	public notify(event: DecisionMakingServiceViewChangedEvent): void {
		if (event.eventType === DecisionMakingServiceViewChangedEvent.EventType) {
			this.viewChanged(event);
		}
	}

	private viewChanged(event: DecisionMakingServiceViewChangedEvent): void {
		if (event.listType === ListType.JOURNEY_EVALUATE && event.viewType === ViewType.DETAIL) {
			store.mutations.setEvaluateView(true);
			return;
		}

		if (
			event.listType === ListType.JOURNEY_APPLY &&
			(event.viewType === ViewType.CREATING || event.viewType === ViewType.DETAIL)
		) {
			store.mutations.setCreatingApplicationChecklistView(true);
			return;
		}

		store.mutations.setEvaluateView(false);
		store.mutations.setCreatingApplicationChecklistView(false);
	}

	public initiate(): void {
		globals.eventAggregationService?.subscribeTo(DecisionMakingServiceViewChangedEvent.EventType, this);
	}
}
